import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import { OfferService } from 'src/app/api/tourism/offer.service';

@Component({
  selector: 'app-offer-form',
  templateUrl: './offer-form.component.html',
  styleUrls: ['./offer-form.component.css']
})
export class OfferFormComponent implements OnInit {
  branchofficeSlug: string = '';
  checkId: number;
  item: FormGroup;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private globalService: GlobalService,
    private offerService: OfferService,
    private route: ActivatedRoute,
    private alertifyMsg: AlertifyHelper,
    private navigationTrackerService: NavigationTrackerService
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.route.snapshot.params['id'];
    this.item = this.fb.group({
      description: ['', [Validators.required, Validators.minLength(2)]],
      content: [null],
      is_show: [false],
      is_top: [false],
      bg_color: [null],
      date_start: [null],
      date_end: [null],
      url_image: [null],
    });

    if (!_.isUndefined(this.checkId)) {
      this.txtSubmenu = environment.txt_edit_menu_form;
      this.isEdit = true;
      this.offerService.get(this.checkId).subscribe({
        next: (data: any) => {
          let item_ = data.data;
          this.item.patchValue({
            description: item_.description,
            content: item_.description,
            is_show: item_.is_show,
            is_top: item_.is_top,
            bg_color: item_.bg_color,
            date_start: item_.date_start,
            date_end: item_.date_end,
            url_image: item_.url_image,
          });
        }
      });
    }
  }

  ngOnInit() {
    this.navigationTrackerService.initializeMenu(this.route);
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  onSubmit() {
    this.submitted = true;
    if (this.item.invalid) {
      return;
    }
    if (this.validate()) {
      if (this.isEdit) {
        this.offerService.update(this.checkId, this.item.value).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro actualizado con éxito');
            this.cancel();
          }
        });
      } else {
        this.offerService.save(this.item.value).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro realizado con éxito');
            this.cancel();
          }
        });
      }
    }
  }

  validate() {
    return true;
  }

  cancel() {
    this.router.navigate([this.branchofficeSlug + '/turismo/ofertas/lista']);
  }
}
